import { UserManager } from '../auth/user-manager';
import { environment } from '../../environments/environment';

export const GLOBAL_MAX_IMAGE_SIZE: number = 102400;

export function makeUrl(url: string, base: string = 'api.cliente'): string {
   //return 'http://localhost:8090/api/cliente' + url;
  // return 'http://191.232.178.143:8089/api/cliente' + url;

   if(environment.production)
    return `https://${base}.smosc.com.br` + url;//`${window.location.protocol}//${window.location.hostname}/api/cliente` + url;
   else {
    return `https://${base}.localhost.smosc.com.br` + url;
   }
    
    //
    //return 'https://localhost:44317/api/cliente' + url;
}

export function makeDocsUrl(url: string): string {
    //return 'http://localhost:8090/api/cliente' + url;
   // return 'http://191.232.178.143:8089/api/cliente' + url;
 
    if(environment.production)
     return 'https://api.docs.smosc.com.br' + url;//`${window.location.protocol}//${window.location.hostname}/api/cliente` + url;
    else {
     return 'https://api.docs.localhost.smosc.com.br' + url;
    }
     
     //
     //return 'https://localhost:44317/api/cliente' + url;
 }

export function makePath(url: string): string {
    return  url;
}

export function makeFiltro(name: string): string {
    return name + '-' + UserManager.getUserInfo()?.username;
}


export function makeRawLocalUrl(url: string): string {
    //return 'http://localhost:8090' + url;
    //return 'http://191.232.178.143:8089/api/cliente' + url;

    if(environment.production)
     //return 'http://smosc.com.br' + url;
     return 'https://api.cliente.smosc.com.br' + url;//`${window.location.protocol}//${window.location.hostname}` + url;
    else {
        return 'https://api.cliente.localhost.smosc.com.br' + url;
    }
     //
     //return 'http://localhost:44300/api/cliente' + url;
 }




 export function makeExport(items: string[] = ['excel', 'csv', 'pdf']): Object[] {
    var toolbarItems: Object[] = [];

    if(items.indexOf('excel') != -1) {
        toolbarItems.push(
        {
         id: 'excelexport', text: 'Excel', prefixIcon: 'e-excelexport', align: 'right', 
         tooltipText: 'Exportar para Excel.'
       });
    }

    if(items.indexOf('csv') != -1) {
        toolbarItems.push(
        {
         id: 'csvexport', text: 'CSV', prefixIcon: 'e-csvexport', align: 'right', 
         tooltipText: 'Exportar para CSV.'
       });
    }

    if(items.indexOf('pdf') != -1) {
        toolbarItems.push(
        {
         id: 'pdfexport', text: 'PDF', prefixIcon: 'e-pdfexport', align: 'right', 
         tooltipText: 'Exportar para PDF.'
       });
    }

    return toolbarItems;
 }









 export function toParams(args: any) {
     return JSON.parse(JSON.stringify(args, (key, value) => {
        if (value !== null) return value
      }));
 }


export interface IResult<T> {
    result: T[],
    count: number
}

 export function toResult(args: any) {
    return  { result: args, count: args.length } ;
}